import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toggleTheme } from "../../../redux/slices/themeSlice";
import unionimage from "../../../assets/icons/Union.svg";
import { Tooltip } from "@mui/material";
import equalizer from "../../../assets/icons/no-music.png";
import gsap from "gsap";
import AudioPlayer from "react-h5-audio-player";
import { useInView } from "react-intersection-observer";
import "react-h5-audio-player/lib/styles.css";
import aot from "../../../assets/songs/aot.mp3";
import logo from "../../../assets/icons/neologo.png";
import logoblue from "../../../assets/icons/neologo.png";
import hamburger from "../../../assets/icons/Hamburger.svg";
import MobileNavbar from "./MobileNavbar";
function Navbar({
    data,
    pageName,
    setPageName,
    setIsMenuOpen,
    isMenuOpen,
    setIsLargeScreen,
    isLargeScreen,
    isPage,
    setisPage,
    pageInView,
    setPageInView,
}) {
    const dispatch = useDispatch();
    const [isMusicPlayed, setIsMusicPlayed] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const { mode } = useSelector((state) => state.theme);
    const [isScrolled, setIsScrolled] = useState(false);
    const menuRef = useRef();
    const navLinks = data.navLinks;

    // For setting navbar to a different design when scrolled
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 250);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth > 1024);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        gsap.set(menuRef.current, { y: "-100%" });
    }, []);

    const audioRef = useRef(null);

    useEffect(() => {
        audioRef.current = new Audio(aot);
        audioRef.current.volume = 0.1;
    }, []);

    const playMusic = () => {
        setIsMusicPlayed(!isMusicPlayed);
        const audio = audioRef.current;
        if (isMusicPlayed) {
            audio.pause(); // Pause the audio if it's already playing
        } else {
            audio.play(); // Play the audio if it's not playing
        }
    };

    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        console.log("clicked", id);

        if (element) {
            let offsetY = 100; // default offset

            // Check if the element's id is "secondPage"
            if (id === "secondpage") {
                offsetY = -140; // increase offset for secondPage
            }

            gsap.to(window, {
                scrollTo: {
                    y: element.offsetTop,
                    offsetY: offsetY,
                },
                ease: "power2.inOut",
            });
        }
    };

    const handleNavigation = (item) => {
        if (item.linkTo === "team") {
            navigate("/team");
            window.scrollTo(0, 0);
        } else if (
            ["projects", "careers", "partners", "secondpage"].includes(
                item.linkTo
            ) &&
            window.location.pathname !== "/"
        ) {
            navigate("/", { state: { scrollToElement: item.linkTo } });
        } else {
            scrollToElement(item.linkTo);
        }
    };

    const handleNormalPageNavigation = (route) => {
        navigate(`/${route}`);
        window.scrollTo(0, 0);
    };
    if (isMenuOpen === true) {
        return (
            <MobileNavbar
                pageName={pageName}
                setIsLargeScreen={setIsLargeScreen}
                isLargeScreen={setIsLargeScreen}
                data={data}
                setPageName={setPageName}
                // setNavbarVisible={setNavbarVisible}
                // handleScrollToComponent={handleScrollToComponent}
                // setScrollToComponent={setScrollToComponent}
                // scrollToComponent={scrollToComponent}
                setIsMenuOpen={setIsMenuOpen}
                isMenuOpen={isMenuOpen}
            />
        );
    }

    const openMenu = () => {
        setIsMenuOpen(true);
        window.scrollTo(0, 0);
    };

    const handlePagination = (item, number) => {
        scrollToElement(item);
        setisPage(number);
    };
    console.log("location", location);
    return (
        <div
            className={`${
                location.pathname === "/press" ? "px-4" : "lg:px-10 px-5"
            } w-full z-40`}
        >
            <div className="z-20 text-white flex justify-between lg:justify-start align-middle items-center pt-10 relative w-full md:w-[90%] mx-auto text-left">
                {isLargeScreen && location.pathname === "/" && (
                    <div className="absolute right-0 transform lg:translate-y-[170%] xl:translate-y-[180%] 2xl:translate-y-[270%]  top-[50%] z-50  ">
                        <div className="flex justify-end gap-4">
                            <p
                                className="h24 text-[12px] cursor-pointer hover:underline duration-100 ease-in"
                                onClick={() => handlePagination("mission", 0)}
                            >
                                Home
                            </p>
                            <div className="mr-2"></div>
                            {}{" "}
                            {pageInView === "mission" && (
                                <div className="duration-500 ease-in-out vertical-line"></div>
                            )}
                        </div>
                        <div className="flex justify-end gap-4">
                            <p
                                className="h24 text-[12px] cursor-pointer hover:underline duration-100 ease-in"
                                onClick={() =>
                                    handlePagination("secondpage", 1)
                                }
                            >
                                01
                            </p>
                            <div className="mr-2"></div>
                            {}{" "}
                            {pageInView === "secondpage" && (
                                <div className="duration-500 ease-in-out vertical-line"></div>
                            )}
                        </div>
                        <div className="flex justify-end gap-4">
                            <p
                                className="h24 text-[12px] cursor-pointer hover:underline duration-100 ease-in"
                                onClick={() => handlePagination("projects", 2)}
                            >
                                02
                            </p>
                            <div className="mr-2"></div>
                            {pageInView === "projects" && (
                                <div className="duration-500 ease-in-out vertical-line"></div>
                            )}
                        </div>
                        <div className="flex justify-end gap-4">
                            <p
                                className="h24 text-[12px] cursor-pointer hover:underline duration-100 ease-in"
                                onClick={() => handlePagination("careers", 3)}
                            >
                                03
                            </p>
                            <div className="mr-2"></div>
                            {pageInView === "careers" && (
                                <div className="duration-500 ease-in-out vertical-line"></div>
                            )}
                        </div>
                    </div>
                )}

                <div className="w-1/3">
                    <img
                        onClick={() => handleNormalPageNavigation("")}
                        src={isLargeScreen ? logo : logoblue}
                        className="w-[50px] lg:w-[150px] cursor-pointer"
                        alt=""
                    />
                </div>
                {isLargeScreen ? (
                    <div className="flex gap-1 lg:gap-8 xl:gap-10 2xl:gap-32 align-middle">
                        {navLinks.map((item) => (
                            <p
                                onClick={() => handleNavigation(item)}
                                className="h11 hover:brightness-150 hover:animate-pulse border-b-2 hover:border-gray-500 border-transparent hover:text-gray-500 h21 lg:text-[12px] xl:text-[14px] 2xl:text-[18px] leading-0 font-light duration-200 ease-in cursor-pointer"
                                key={item.name}
                            >
                                {item.name}
                            </p>
                        ))}
                    </div>
                ) : (
                    <div>
                        <img
                            src={hamburger}
                            onClick={openMenu}
                            className="cursor-pointer"
                            alt=""
                        />
                    </div>
                )}
                {isLargeScreen && (
                    <div className="absolute right-0">
                        <a href="mailto:ssiddarthsai1999@gmail.com">
                            <img
                                src={unionimage}
                                className="cursor-pointer"
                                alt=""
                            />
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Navbar;
